// Copy mirrors www.brxs.ca/pricing (bricks-prelaunch src/lib/catalog.ts SOFTWARE_PLANS/ADDONS).
// Prices mirror BILLING_PACKAGES. Do not add claims that are not on www.
export const AI_ADDONS = [
  { name: 'AI Listing Copy', monthly: 19 },
  { name: 'AI CMA', monthly: 25 },
  { name: 'AI Document Drafter', monthly: 19 },
];
export const AI_ADDONS_MONTHLY = AI_ADDONS.reduce((n, a) => n + a.monthly, 0);
export const PLAN_DATA = {
  clay: {
    id: 'clay', name: 'Clay', price: 0, annualPrice: 0,
    inherits: null,
    features: ['Book media at rack rate', 'Listing file, transactions, and BYO MLS'],
  },
  keystone: {
    id: 'keystone', name: 'Keystone', price: 49, annualPrice: 490,
    inherits: 'Clay',
    features: ['CRM', 'Checklist e-sign + shareable links (on-document PDF placement not available yet)'],
  },
  marble: {
    id: 'marble', name: 'Marble', price: 99, annualPrice: 990,
    inherits: 'Keystone',
    features: ['Forms'],
  },
  diamond: {
    id: 'diamond', name: 'Diamond', price: 149, annualPrice: 1490,
    inherits: 'Marble',
    features: ['AI suite included — same AI as add-ons on lower plans', ...AI_ADDONS.map((a) => `${a.name} included`)],
  },
};

export function money(n) {
  return `$${n.toLocaleString('en-US', Number.isInteger(n) ? undefined : { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function planValueLine(plan, annual) {
  if (plan.price === 0) return 'Free. No card.';
  const base = annual
    ? `${money(Math.round((plan.annualPrice / 12) * 100) / 100)}/mo, billed yearly`
    : `or ${money(plan.annualPrice)}/yr billed yearly`;
  return plan.id === 'diamond' ? `${base}. AI suite included.` : base;
}

// One recommended tier, shown everywhere plans appear.
export const RECOMMENDED_PLAN = 'marble';

/** "Everything in Keystone, plus Forms" — cumulative one-liner for compact lists. */
export function cumulativeLine(plan) {
  return plan.inherits ? `Everything in ${plan.inherits}, plus ${plan.features.join(', ')}` : plan.features.join(', ');
}

// Feature matrix: identical row order on every card. `from` = first tier that includes it.
// Labels are www.brxs.ca/pricing claims. AI rows are add-ons below Diamond (www ADDONS).
export const PLAN_ORDER = ['clay', 'keystone', 'marble', 'diamond'];
export const FEATURE_ROWS = [
  { label: 'Book media at rack rate', from: 'clay' },
  { label: 'Listing file, transactions, and BYO MLS', from: 'clay' },
  { label: 'CRM', from: 'keystone' },
  { label: 'Checklist e-sign + shareable links', note: 'On-document PDF placement not available yet', from: 'keystone' },
  { label: 'Forms', from: 'marble' },
  { label: 'AI Listing Copy', from: 'diamond', addon: 19 },
  { label: 'AI CMA', from: 'diamond', addon: 25 },
  { label: 'AI Document Drafter', from: 'diamond', addon: 19 },
];
/** 'new' (first tier with it) | 'inherited' | 'addon' (paid add-on on this tier) | 'no' */
export function rowState(row, planId) {
  const at = PLAN_ORDER.indexOf(planId), from = PLAN_ORDER.indexOf(row.from);
  if (at === from) return 'new';
  if (at > from) return 'inherited';
  if (row.addon && planId !== 'clay') return 'addon';
  return 'no';
}
export function includedCount(planId) {
  return FEATURE_ROWS.filter((r) => ['new', 'inherited'].includes(rowState(r, planId))).length;
}
